import URLS from "../constants/api";
import { get_2 } from "./api";

export const downloadBenefitsAPI = async () => {
    
    const response = await get_2(URLS.DOWNLOAD_BENEFITS);
    return response;
  };